import { columns } from './columns'
import createState from '../_defaults/state'
import createGetters from '../_defaults/getters'
import createMutations from '../_defaults/mutations'
import createActions from '../_defaults/actions'

/* -------- CONFIG ----------- */
export const apiEndpoint = '/api/file'
export const namespace = 'file'
export const clientRoute = '/file'
export const dependencies = []
export const params = {
  include: ''
}
/* --------------------------- */

const state = {
  columns,
  apiEndpoint,
  namespace,
  dependencies,
  clientRoute,
  params
}

export default {
  namespaced: true,
  state: createState(Object.assign(state, { namespace })),
  getters: createGetters(),
  mutations: createMutations(),
  actions: createActions()
}
